export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex flex-col lg:flex-row">
      {/* Left Panel - Text Content */}
      <div className="w-full lg:w-1/2 bg-background-100 flex items-center">
        <div className="w-full px-6 md:px-12 lg:px-16 xl:px-24 py-32 lg:py-0">
          <div className="max-w-[540px] mx-auto lg:mx-0">
            <p className="text-[12px] font-label font-semibold tracking-[0.2em] text-foreground-500 uppercase mb-6">
              Curated Pandabuy Spreadsheet Platform
            </p>
            <h1 className="font-heading text-[42px] md:text-[56px] lg:text-[64px] leading-[1.08] text-foreground-950 font-bold tracking-[-0.02em] text-balance">
              Best Pandabuy Spreadsheet for Sneakers, Streetwear &amp; Budget Finds
            </h1>
            <p className="mt-6 text-[15px] md:text-[16px] text-foreground-600 leading-relaxed max-w-[460px]">
              Discover curated Pandabuy spreadsheet lists with real-time updated fashion finds,
              sneaker deals, and streetwear essentials — optimized for price, quality, and
              shipping efficiency.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row items-start gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-foreground-900 text-background-50 text-[14px] font-label font-semibold rounded-full hover:bg-foreground-950 transition-all duration-300 whitespace-nowrap cursor-pointer group"
              >
                Pandabuy Sheet
                <span className="w-6 h-6 rounded-full border border-background-50/30 flex items-center justify-center group-hover:border-background-50/60 transition-colors">
                  <i className="ri-arrow-right-up-line text-xs"></i>
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 border border-foreground-200 text-foreground-800 text-[14px] font-label font-semibold rounded-full hover:border-foreground-400 hover:text-foreground-950 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-line text-sm"></i>
              </a>
            </div>

            {/* Trust Stats */}
            <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-6">
              {[
                { value: "10,000+", label: "Curated Products" },
                { value: "Daily", label: "Updated Spreadsheet" },
                { value: "Verified", label: "Community Picks" },
                { value: "Fast", label: "Shipping Insights" },
              ].map((stat) => (
                <div key={stat.label}>
                  <p className="text-[20px] md:text-[22px] font-heading font-bold text-foreground-900">
                    {stat.value}
                  </p>
                  <p className="text-[12px] text-foreground-500 font-body mt-0.5">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel - Image */}
      <div className="w-full lg:w-1/2 h-[420px] md:h-[600px] lg:h-screen relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20minimal%20fashion%20still%20life%20with%20cream%20colored%20sneakers%20and%20a%20folded%20beige%20hoodie%20on%20a%20clean%20concrete%20surface%20warm%20golden%20hour%20sunlight%20streaming%20from%20left%20creating%20long%20soft%20shadows%20neutral%20cream%20and%20sand%20palette%20elegant%20editorial%20composition%20high%20end%20minimal%20product%20photography%20serene%20atmospheric%20mood&width=1440&height=1800&seq=hero-main-v2-2026&orientation=portrait"
            alt="Curated Pandabuy spreadsheet fashion finds collection"
            title="Pandabuy Spreadsheet - Best Fashion Finds 2026"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>
        </div>
      </div>
    </section>
  );
}